import { graphql } from 'react-relay';
export const AnnotationStateQuery = graphql`
	query AnnotationStateQuery($pageId: ID!, $contentStatus: [GraphQLContentStatus]) {
		comments(
			pageId: $pageId
			contentStatus: $contentStatus
			type: [INLINE, UNRESOLVED]
			depth: ROOT
			first: 1500
		) {
			nodes {
				id
				location {
					type
					... on InlineComment {
						inlineMarkerRef
						inlineResolveProperties {
							resolved
							resolvedUser
						}
					}
				}
			}
		}
	}
`;
